import { SanityCountry } from '@dap/memberadmin/types';

// Since we are not using the kjedeadmin Sanity instance, we define the countries here instead
export const countriesList: SanityCountry[] = [
  { _id: '1', code: 'NO', name: { nb: 'Norge', sv: 'Norge', en: 'Norway' }, isStandard: true },
  { _id: '2', code: 'SE', name: { nb: 'Sverige', sv: 'Sverige', en: 'Sweden' }, isStandard: true },
  { _id: '3', code: 'FI', name: { nb: 'Finland', sv: 'Finland', en: 'Finland' }, isStandard: true },
  {
    _id: '4',
    code: 'DE',
    name: { nb: 'Tyskland', sv: 'Tyskland', en: 'Germany' },
    isStandard: true,
  },
  {
    _id: '5',
    code: 'AT',
    name: { nb: 'Østerrike', sv: 'Österrike', en: 'Austria' },
    isStandard: true,
  },
  { _id: '6', code: 'DK', name: { nb: 'Danmark', sv: 'Danmark', en: 'Denmark' }, isStandard: true },
  { _id: '7', code: 'EE', name: { nb: 'Estland', sv: 'Estland', en: 'Estonia' }, isStandard: true },
  {
    _id: '8',
    code: 'GB',
    name: { nb: 'Storbritannia', sv: 'Storbritannien', en: 'United Kingdom' },
    isStandard: true,
  },
  { _id: '9', code: 'IE', name: { nb: 'Irland', sv: 'Irland', en: 'Ireland' }, isStandard: true },
  {
    _id: '10',
    code: 'LT',
    name: { nb: 'Litauen', sv: 'Litauen', en: 'Lithuania' },
    isStandard: true,
  },
];

export const getCountryOptions = (
  selectedCountry?: string,
  language?: string
): Array<{ value: string; name: string }> => {
  const selectedCountryCode = selectedCountry?.toUpperCase();

  return countriesList
    .filter((country) => country.isStandard || selectedCountryCode === country.code.toUpperCase())
    .map((country) => ({
      value: country.code,
      name: country.name[language as keyof typeof country.name] || country.code,
    }));
};

export const getCountryName = (countryCode?: string, language?: string): string => {
  if (!countryCode) return '';
  const country = countriesList.find((c) => c.code.toUpperCase() === countryCode.toUpperCase());
  if (!country) return countryCode;
  return country.name[language as keyof typeof country.name] || countryCode;
};
